import { mapActions, mapGetters, mapMutations } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";

export default {
    name: "cookie-agreement",
    data() {
        return {};
    },
    mixins: [dynamicHead],
    computed: {
        ...mapGetters({
            cookieAgreement: "support/cookieAgreement",
        }),
    },
    mounted() {
        this.getCookieAgreement().then(() => {
            this.setPageItem(this.cookieAgreement);
        });
    },
    methods: {
        ...mapActions({
            getCookieAgreement: "support/GET_COOKIE_AGREEMENT",
        }),
        ...mapMutations({}),
    },
    destroyed() {},
};
